import Point from "@arcgis/core/geometry/Point";
import Graphic from "@arcgis/core/Graphic";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import axios from "axios";
import { loadModules, setDefaultOptions } from "esri-loader";
import { changeLocationMarker } from "./../../../lib/Customer/MarkersFunctions/changeLocationMarker";
import { newPos, setInformationModal, setMarkerState, setRightClick, setShowInfoModal, setToolTipModal, toggleRoofConfirmBtn } from "./../../../ReduxTool/Slice/Map/MapReducer";
import { setLocationPinLatLng } from "./../../../ReduxTool/Slice/Marker/MarkersReducer";
import { resetReducerAnalysis, resetRoofAnalisisForm, setnewAddress } from "./../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { AppDispatch } from "./../../../ReduxTool/store/store";
import { IUpdateEvent, LocationMarker } from "./../../Const";
import { getSymbol, markerSymbol } from "./../../CustomerMaps/MarkerSymbols/MarkerSymbols";
import { loadEsriModules } from "./getEsriModules";
import globalLayers from "./GlobaLMap";
import { setLatlng, setSerachedLocation } from "../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { setTitle, toggleDrawer } from "../../../ReduxTool/Slice/Drawer/DrawerReducer";
import { fetchCompleteAddressStr, getfilterObjKeysByArr } from "../../commonFunctions";
import MapView from "@arcgis/core/views/MapView";

setDefaultOptions({ css: true });

export const loadMultipleModules = async (moduleNames: string[]) => {
    const loadedModules = await loadModules(moduleNames);
    return loadedModules;
};

export const getCustomSearchSource = async (): Promise<__esri.SearchSource> => {
    const [SearchSource] = await loadMultipleModules(["esri/widgets/Search/SearchSource"]);
    const searchSource = new SearchSource();
    searchSource.placeholder = "Enter Address"; // Change the placeholder text

    return searchSource;
};

//locator
// Function to get the state name from coordinates
// One reverse-geocode request per point for the whole session. Every helper below (state, city, address, country,
// complete address) reads a different field of the same ArcGIS answer, and effects re-run them on each project
// update, so without this the same point was requested again on almost every save/click. Concurrent calls for
// a point share one request. In memory only (ArcGIS terms restrict storing geocode results); failures aren't kept.
const REVERSE_GEOCODE_URL = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode";
const REVERSE_GEOCODE_CACHE_SIZE = 200;
const reverseGeocodeCache = new Map<string, Promise<Record<string, any> | null>>();

/** ArcGIS reverse-geocode `address` attributes (Region, City, MetroArea, Match_addr, CntryName, Postal, ...) or null when none. */
export const reverseGeocode = (lat: number, lng: number): Promise<Record<string, any> | null> => {
    if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return Promise.resolve(null);
    // ~0.1 m: the same marker/project point always maps to the same key
    const key = `${Number(lat).toFixed(6)},${Number(lng).toFixed(6)}`;
    const cached = reverseGeocodeCache.get(key);
    if (cached) return cached;

    const request = axios.get(REVERSE_GEOCODE_URL, { params: { location: `${lng},${lat}`, outSR: 4326, f: "json" } })
        .then(({ data }) => (data?.address as Record<string, any>) ?? null)
        .catch((error) => {
            reverseGeocodeCache.delete(key); // retry next time
            throw error;
        });
    reverseGeocodeCache.set(key, request);
    if (reverseGeocodeCache.size > REVERSE_GEOCODE_CACHE_SIZE) {
        reverseGeocodeCache.delete(reverseGeocodeCache.keys().next().value!);
    }
    return request;
};

export const getStateFromCoordinates = async (longitude: number, latitude: number) => {
    try {
        const address = await reverseGeocode(latitude, longitude);

        if (address) {
            // Access the state (Region) name
            const stateName = address.Region;
            return stateName;
        } else {
            console.warn("State name not found for the given coordinates.");
            return null;
        }
    } catch (error) {
        console.error("Error getting state name:", error);
        return null;
    }
};

export const getCityFromCoordinates = async (longitude: number, latitude: number) => {
    try {
        const address = await reverseGeocode(latitude, longitude);

        if (address) {
            // Access the state (Region) name
            const stateName = address.MetroArea ? address.MetroArea : address.CntryName ;
            return stateName;
        } else {
            console.warn("State name not found for the given coordinates.");
            return null;
        }
    } catch (error) {
        console.error("Error getting state name:", error);
        return null;
    }
};

export const lazyLoadArcGisMapModules = async () => {
    const [SceneView, Map, Search, GraphicsLayer, MapView, Editor, SnappingControls, watchUtils, reactiveUtils, GroupLayer, Sketch, GeoJSONLayer, Polygon,BingMapsLayer,BasemapToggle] = await loadMultipleModules(["esri/views/SceneView", "esri/Map", "esri/widgets/Search", "esri/layers/GraphicsLayer", "esri/views/MapView", "esri/widgets/Editor", "esri/widgets/support/SnappingControls", 'esri/core/watchUtils', 'esri/core/reactiveUtils', 'esri/layers/GroupLayer', 'esri/widgets/Sketch', 'esri/layers/GeoJSONLayer', 'esri/geometry/Polygon','esri/layers/BingMapsLayer',"esri/widgets/BasemapToggle"]);
    return { SceneView, Map, Search, GraphicsLayer, MapView, Editor, SnappingControls, watchUtils, reactiveUtils, GroupLayer, Sketch, GeoJSONLayer, Polygon, BingMapsLayer,BasemapToggle };
}



export const getGraphicLayer = () => {
    return new GraphicsLayer();
}





export const addDrawEvents = async (view: MapView, dispatch: AppDispatch): Promise<MapView> => {
    globalLayers.changeView = document.getElementById("changeActiveView");
    // globalLayers.addSketchDraw();
    return view
}

export const addMeasurementTools = async (view: __esri.SceneView) => {
};

export const renderer = {
    type: "unique-value", // autocasts as new UniqueValueRenderer()
    defaultSymbol: getSymbol("#FFFFFF"),
    defaultLabel: "Other",
    field: "TYPE",
    visualVariables: [
        {
            type: "size",
            field: "Max_Elev_F"
        }
    ]
};

export const addFeatureLayer = async (lat?: number, lng?: number) => {
    const [LayerList] = await loadMultipleModules(["esri/widgets/LayerList"])

    // Set the renderer on the layer
    if (globalLayers.featureLayers.layerlist) {
        globalLayers.map?.allLayers.forEach(ele => {
            if (ele.title === "Extruded building footprints") {
                globalLayers.map?.remove(ele)

            }
        })
    }

    globalLayers.featureLayers.layerlist = new LayerList({
        view: globalLayers.view,
        title: "layerList",
    });
};

export const getShadowCastWidget = async () => {
    loadMultipleModules(["esri/widgets/esri/ShadowCast"])
        .then(([ShadowCast]) => {
            globalLayers.shadowCastWidget = new ShadowCast({
                view: globalLayers.view,
            })
        })
        .catch(e => {
            return null
        })
};





export const getAddressFromPinDropCoordinates = async (longitude: number, latitude: number) => {
    try {
        const address = await reverseGeocode(latitude, longitude);

        if (address) {
            const matchAddressName = address.Match_addr;
            return matchAddressName;
        } else {
            console.warn("Region name not found for the given coordinates.");
            return null;
        }
    } catch (error) {
        console.error("Error getting region name:", error);
        return null;
    }
};




export const fetchCountryNamefromLatLng = async (lat: number, lng: number) => {
    try {
      const address = await reverseGeocode(lat, lng);
      if (address && address.CntryName) {
        const country = address.CntryName;
      return country;
      } else {
       console.log('Country not found');
      }
    } catch (error) {
      console.error('Error fetching country:', error);
    }
  };

//  export const fetchCompleteAddress = async (lat: number, lng: number) => {
//     const url = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?location=${lng},${lat}&outSR=4326&f=json`;
 
//     try {
//       const response = await axios.get(url);
//       if (response.data && response.data.address&&response.data.address.CntryName) {
//          const completeaddress = `${response.data.address.Addr_type}, ${response.data.address.City}, ${response.data.address.District}, ${response.data.address.Region}, ${response.data.address.ShortLabel}, ${response.data.address.CountryCode}`
//       return completeaddress;
//       } else {
//        console.log('Country not found');
//       }
//     } catch (error) {
//       console.error('Error fetching country:', error);
//       console.log('Error fetching country');
//     }
//   };

  export const fetchCompleteAddress = async (lat: number, lng: number,isStringFormat?:boolean,fieldsReq?:any[]) => {
    try {
      const address = await reverseGeocode(lat, lng);
      const data = { address };
      if (data && data.address && data.address.CntryName) {
          let addressobj: any = {
              city: data.address.City,
              district: data.address.District,
              state: data.address.Region,
              pincode: data.address.Postal,
              countryAbbr: data.address.CountryCode
          }
        if (!isStringFormat) {
            addressobj.regionAbbr = data.address.RegionAbbr;
            addressobj.country = data.address.CntryName;
        }
        if(fieldsReq){
            addressobj =  getfilterObjKeysByArr(addressobj,fieldsReq);
        }
        if(isStringFormat){ 
            addressobj = fetchCompleteAddressStr(addressobj); // Removes undefined or empty values
        }
        return addressobj;
      } else {
       console.log('Country not found');
      }
    } catch (error) {
      console.error('Error fetching country:', error);
      console.log('Error fetching country');
    }
  };

  export const getCoordinatesFromAddress = async (address: string) => {
    try {
        const [locator] = await loadEsriModules(['esri/rest/locator']);
        let url = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer";

        // Use the locator to geocode the address
        const results = await (locator as __esri.locator).addressToLocations(url, {
            address: { SingleLine: address },
            maxLocations: 1
        });

        if (results && results.length > 0) {
            const location = results[0].location;
            const coordinates = {
                latitude: location.y,
                longitude: location.x
            };
            return coordinates;
        } else {
            console.warn("Coordinates not found for the given address.");
            return null;
        }
    } catch (error) {
        console.error("Error getting coordinates:", error);
        return null;
    }
};

